import {defineRouting} from 'next-intl/routing';
 
export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['kz', 'ru', 'en'],
  // Used when no locale matches
  defaultLocale: 'kz',
  localeDetection: true,
});